import {Question} from '@/state/models/Question';

export class QuestionPassFail extends Question {
    constructor(id: number, text?: string) {
        super(id, text, 'passfail', 'pass');
    }
}
